module.exports = __webpack_public_path__ + "static/media/report.9d94ceab.svg";